import React from "react";
import Layout from './Layout';
import { EmergencyContact } from "../../components/User/Emergency";

export const EmergencyPage = () => <Layout><EmergencyContact></EmergencyContact></Layout> 
